import { faSquareCheck, faSquare } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { isAlgarDeskSelector, isBtoBSelector } from '../../selectors';
import { stepsSelector } from '../../selectors/step';
import { formatDate } from '../../utils/date';
import { Square, SquareContainer, SquareIcon, StepNameV2, StepsWrapper, StepsWrapperContent, StepsWrapperTitle, StepV2 } from './styled';
const stepsWrapperContentId = '__Steps__Wrapper__Content__Id__';
let StepContainer = _ref => {
  let {
    step,
    steps,
    isLast,
    wrapperHeight,
    stepsLength,
    nextStep,
    index
  } = _ref;
  let projectSteps = useSelector(stepsSelector);
  if (projectSteps === [] || null || undefined || projectSteps.length === 0) {
    projectSteps.push({
      "name": "error pas de suivis",
      "metaCode": "error_not_defined"
    });
  }
  let lastStep = projectSteps[projectSteps.length - 1];
  const resultStep = [];
  for (let i = 0; i < steps.length; i++) {
    if (steps[i].code === lastStep.metaCode) {
      for (let j = 0; j < i; j++) {
        resultStep.push({
          "name": steps[j].name,
          "metaCode": steps[j].code
        });
      }
      break;
    }
  }
  resultStep.push({
    "name": lastStep.name,
    "metaCode": lastStep.metaCode
  });
  const projectStepCodes = resultStep.map(_ref2 => {
    let {
      metaCode
    } = _ref2;
    return metaCode;
  });
  const lineHeight = wrapperHeight / stepsLength - 7;
  const completedStep = resultStep.find(_ref3 => {
    let {
      metaCode
    } = _ref3;
    return metaCode === step.code;
  });
  const isCompleted = completedStep && completedStep.metaCode === step.code;
  const isCompletedNext = nextStep && projectStepCodes.includes(nextStep.code);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StepV2, null, /*#__PURE__*/React.createElement(StepNameV2, null, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, step.name)), /*#__PURE__*/React.createElement(SquareContainer, {
    isLast: isLast,
    lineHeight: lineHeight,
    isCompleted: nextStep ? isCompletedNext : isCompleted,
    done: isCompleted
  }, isCompleted || isCompletedNext ? /*#__PURE__*/React.createElement(SquareIcon, {
    icon: faSquareCheck
  }) : /*#__PURE__*/React.createElement(SquareIcon, {
    icon: faSquare
  }))));
};
const stepPropTypeShape = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired
};
StepContainer.propTypes = {
  step: PropTypes.shape(stepPropTypeShape).isRequired,
  nextStep: PropTypes.shape(stepPropTypeShape),
  wrapperHeight: PropTypes.number.isRequired,
  stepsLength: PropTypes.number.isRequired
};
const ViewSteps = _ref4 => {
  let {
    steps
  } = _ref4;
  let projectSteps = useSelector(stepsSelector);

  // DPC Suppression des metacodes dans steps si elles ne figurent pas dans projectSteps ( valeur metacode valider )
  const filterSteps = (steps, projectSteps) => {
    // Liste des metaCodes à retirer si non présents dans projectSteps
    const excludedMetaCodes = ["analyzingMayorRequest", "mayorRequestV1Feedback", "mayorRequestSent", "mayorRequestReceived"];

    // Récupérer tous les metaCodes présents dans projectSteps
    const projectStepCodes = projectSteps.map(_ref5 => {
      let {
        metaCode
      } = _ref5;
      return metaCode;
    });

    // Filtrer les étapes
    return steps.filter(step => {
      // Exclure les étapes si leur metaCode est dans la liste d'exclusion
      // ET qu'il n'est pas présent dans projectStepCodes
      return !(excludedMetaCodes.includes(step.code) && !projectStepCodes.includes(step.code));
    });
  };
  // Filtrer les étapes en excluant les metaCodes inutiles
  const filteredSteps = filterSteps(steps, projectSteps);
  const isBtoB = useSelector(isBtoBSelector);
  const isDesk = useSelector(isAlgarDeskSelector);
  const [stepsWrapperContentHeight, setStepsWrapperContentHeight] = useState(0);
  React.useEffect(() => {
    const el = document.getElementById(stepsWrapperContentId);
    if (el) setStepsWrapperContentHeight(el.scrollHeight);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepsWrapperTitle, null, "Suivi"), /*#__PURE__*/React.createElement(StepsWrapperContent, {
    btobStepper: isBtoB,
    deskStepper: isDesk,
    id: stepsWrapperContentId
  }, filteredSteps.map((step, index) => {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: `step-${step.id}`
    }, /*#__PURE__*/React.createElement(StepContainer, {
      step: step,
      steps: filteredSteps,
      nextStep: filteredSteps[index + 1],
      isLast: index + 1 >= filteredSteps.length,
      wrapperHeight: stepsWrapperContentHeight,
      stepsLength: filteredSteps.length,
      index: index
    }));
  })));
};
ViewSteps.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape(stepPropTypeShape).isRequired).isRequired
};
export default ViewSteps;